module.exports = __webpack_public_path__ + "img/fossil3Img2.05842785.jpg";